export const CASES_PREFIX = 'cases' as const;
